import { useHttp } from '@/shared/lib'
import { computed, type Ref } from 'vue'
import { useQuery } from '@tanstack/vue-query'

export const useLoadInventDocuments = (filter: Ref<{ type: string }>) => {
  const http = useHttp()

  const url = computed(() => {
    const searchParams = new URLSearchParams(filter.value)
    return `/inventory/objects/documents?${searchParams}`
  })

  const queryKey = computed(() => ['load_invent_documents', filter])

  return useQuery({
    queryKey,
    queryFn: () => http.get(url.value),
    retry: false,
  })
}
